module.exports = __webpack_public_path__ + "static/media/sfx_animal_monkey_01.2cbf0982.mp3";